$(document).ready(function () {
  $(".messure_info").click(function () {
    $(".info_first").toggle();
  });
  $(".motive_color").click(function () {
    $(".info_second").toggle();
  });
  var current_action = "inches";
  $(".custom-size-action-radio").change(function () {
    var $this = $(this);
    $(".mesure").hide();
    $(".mesure :input").attr("disabled", "disabled");
    destroycroper();
    if ($this.is(":checked")) {
      current_action = $this.val();
      if (current_action == "inches") {
        $(".inc_container").show();
        $(".inc_container :input").removeAttr("disabled");
      } else if (current_action == "cm") {
        $(".cm_container").show();
        $(".cm_container :input").removeAttr("disabled");
      } else {
        alert("Invalid action");
        return false;
      }
    }
  });

  /*********Croper**************/
  var is_init = false;
  var image_ratio = 1;
  var height_set = 500;
  var width_set = 500;
  var original_image_customer = "";

  var resolution = "";
  var width_render = "";
  var height_render = "";
  var width_pass = "";
  var height_pass = "";
  var quantity = "";
  var cropper = "";

  //setPriceInit();
  setPriceFirstVariantInit();
  function getPrice() {
    return $(".base_price").attr("data-price");
    //return $('.selected-variant').attr('data-price');
  }
  function setPriceInit() {
    var price = $(".base_price").attr("data-price");
    price = (price / 100).toFixed(2);
    $(".base_price").attr("data-price", price);
  }
  function setPriceFirstVariantInit() {
    var price = $(".base_price").attr("data-price");
    price = (price / 100).toFixed(2);
    $(".base_price").attr("data-price", price);
    $("#prd_price").text(price);
    $(".price-item").html("$" + price);
    updateComparePrice($(".selected-variant"), 1);
  }
  function setPrice(price) {
    var final = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    $("#prd_price").text(final);
    $(".m_s").hide();
  }

  function updateComparePrice($variant, multiplier) {
    var compareAtPrice = parseFloat($variant.attr("data-compare-at-price") || 0);
    var salePrice = parseFloat($variant.attr("data-price") || 0);
    var $compare = $(".product-original-price");

    if (compareAtPrice > salePrice) {
      var formatted = ((compareAtPrice / 100) * (multiplier || 1)).toFixed(2);
      formatted = String(formatted).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      $("#prd_compare_price").text(formatted);
      $compare.show();
    } else {
      $compare.hide();
    }
  }

  function filter_price(price) {
    return parseInt(price / 100) + "." + (price % 100);
  }

  $(".action-set").on("click", function () {
    var $this = $(this);

    $(".action-set").removeClass("selected-variant");
    $this.addClass("selected-variant");
var price = $this.attr("data-price");
price = (price / 100).toFixed(2);
    $(".base_price").attr("data-price", price);
    $(".price-item").html("&#163;" + price);
    var size_price = $(".sizes-container").attr("data-price");

if (size_price !== "") {
  price = parseFloat(size_price) * parseFloat(price);

  price = price.toFixed(2);
  price = String(price).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}

    $("#prd_price").text(price);
    updateComparePrice($this, size_price !== "" ? parseFloat(size_price) : 1);
  });

  function destroycroper() {
    var price = $(".selected-variant").attr("data-price");
    price = (price / 100).toFixed(2);
    price = String(price).replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    $(".base_price").attr("data-price", price);
    $(".sizes-container").attr("data-price", "");

    $("#prd_price").text(price);
    updateComparePrice($(".selected-variant"), 1);
    $(".croper_main_image").hide();
    $(".product-media-custom").show();
    $(".share-pinterest").show();
        $(".wfc-add-to-cart").removeClass('add-gif');
    if (is_init) {
      cropper.destroy();
    }
    $(".inputsize").val("");
  }

  $("body").on("paste keyup input", ".inputsize", function () {
    if (current_action == "inches") {
      if ($(".in_width").val() > 0 && $(".in_height").val() > 0) {
        width_render = $(".in_width").val() + "inches";
        height_render = $(".in_height").val() + "inches";

        quantity = convert_into(
          $(".in_width").val(),
          $(".in_height").val(),
          "inches"
        );
        $(".sizes-container").attr("data-price", quantity);
        var result_out = quantity * getPrice();
        var result_out = result_out.toFixed(2);
        setPrice(result_out);
        updateComparePrice($(".selected-variant"), quantity);
        image_ratio = $(".in_width").val() / $(".in_height").val();
        init_cropper();
      } else {
        if (is_init) {
          cropper.destroy();
        }
        $(".croper_main_image").hide();
        $(".product-media-custom").show();
        $(".share-pinterest").show();$(".wfc-add-to-cart").removeClass('add-gif');
        return false;
      }
    }else if (current_action == "cm") {
      if ($(".cm_width").val() > 0 && $(".cm_height").val() > 0) {
        var width = convert_into($(".cm_width").val(), "cm");
        var height = convert_into($(".cm_height").val(), "cm");

        width_render = $(".cm_width").val() + "cm";
        height_render = $(".cm_height").val() + "cm";

        quantity = convert_into(
          $(".cm_width").val(),
          $(".cm_height").val(),
          "cm"
        );
        $(".sizes-container").attr("data-price", quantity);

        var result_out = quantity * getPrice();
        var result_out = result_out.toFixed(2);
        //console.log("RESULT::: "+result_out);
        setPrice(result_out);
        updateComparePrice($(".selected-variant"), quantity);
        image_ratio = $(".cm_width").val() / $(".cm_height").val();
        init_cropper();
      } else {
        if (is_init) {
          cropper.destroy();
        }
        $(".croper_main_image").hide();
        $(".product-media-custom").show();
        $(".share-pinterest").show();$(".wfc-add-to-cart").removeClass('add-gif');
        return false;
      }
    } else {
    }
    //console.log(current_action +" -  "+$(this).val());
  });

  function convert_into(w, h, type) {
    if (type == "cm") {
      return Math.ceil(w * h * 0.00107639104167);
    } else if (type == "inches") {
      return Math.ceil(w * h * 0.00694444444444);
    } else if (type == "unitfeet") {
      return Math.ceil(w * h);
    }
  }
  // function init_cropper() {
  //   $(".product-media-custom").hide();
  //   $(".croper_main_image").show();
  //   $(".wfc-add-to-cart").addClass('add-gif');
  //   $(".share-pinterest").hide();
  //   if (is_init) {
  //     cropper.destroy();
  //   }
  //   is_init = true;
  //   var image = document.getElementById("crop_image_main");
  //   var save = document.getElementById("save");
  //   var original_image_customer = image.src;

  //   image.style.visibility = "visible";
  //   cropper = new Cropper(image, {
  //     aspectRatio: image_ratio,
  //     viewMode: 1,
  //     center: !1,
  //     zoomable: !1,
  //     checkCrossOrigin: true,
  //     checkOrientation: !1,
  //     dragMode: "none",
  //     autoCropArea: 1,
  //     rotatable: true,
  //     cropBoxResizable: 1,
  //     scalable: true,
  //     movable: !1,
  //     //option:{ "width": width_set, "height": height_set },
  //     ready: function () {
  //       croppable = true;
  //     },
  //   });
  // }

function init_cropper() {
  $(".product-media-custom").hide();
  $(".croper_main_image").show();
  $(".wfc-add-to-cart").addClass("add-gif");
  $(".share-pinterest").hide();

  if (is_init && cropper) {
    cropper.destroy();
  }

  is_init = true;

  var image = document.getElementById("crop_image_main");
  image.style.visibility = "visible";

  cropper = new Cropper(image, {
    aspectRatio: image_ratio,
    viewMode: 1,

    // 只允许拖动裁剪框，不允许重新画框
    dragMode: "move",

    autoCropArea: 1,

    // 不允许通过边角缩放裁剪框
    cropBoxResizable: false,

    // 允许拖动裁剪框位置
    cropBoxMovable: true,

    // 禁止用户缩放图片
    zoomable: false,
    zoomOnWheel: false,
    zoomOnTouch: false,

    // 禁止移动图片本身
    movable: false,

    // 必须保留 true，否则 mirror 翻转会失效
    scalable: true,

    rotatable: true,
    center: false,
    checkCrossOrigin: true,
    checkOrientation: false,
    toggleDragModeOnDblclick: false,

    ready: function () {
      croppable = true;

      var canvasData = cropper.getCanvasData();

      var cropWidth;
      var cropHeight;

      var canvasRatio = canvasData.width / canvasData.height;

      // 输入尺寸比例更宽：宽度顶满
      if (image_ratio >= canvasRatio) {
        cropWidth = canvasData.width;
        cropHeight = cropWidth / image_ratio;
      }
      // 输入尺寸比例更高：高度顶满
      else {
        cropHeight = canvasData.height;
        cropWidth = cropHeight * image_ratio;
      }

      var cropLeft = canvasData.left + (canvasData.width - cropWidth) / 2;
      var cropTop = canvasData.top + (canvasData.height - cropHeight) / 2;

      cropper.setCropBoxData({
        width: cropWidth,
        height: cropHeight,
        left: cropLeft,
        top: cropTop
      });

      // 关键：最小尺寸锁死为当前顶满尺寸，防止被缩小
      cropper.options.minCropBoxWidth = cropWidth;
      cropper.options.minCropBoxHeight = cropHeight;

      // 保险：隐藏所有边角缩放点
      $(".cropper-line, .cropper-point").hide();
    },
    cropstart: function (event) {
      var action = event.detail.action;

      // 只允许移动，不允许任何方向缩放
      if (
        action === "e" ||
        action === "w" ||
        action === "n" ||
        action === "s" ||
        action === "ne" ||
        action === "nw" ||
        action === "se" ||
        action === "sw"
      ) {
        return false;
      }
    }
  });
}



  $("#mirror_set").change(function () {
    if ($(this).is(":checked")) {
      cropper.scale(-1, 1);
    } else {
      cropper.scale(1);
    }
  });

$(document).on('click', '.add-gif', function() {
   $(".loading-product").removeClass("hidden-leo");
});

  
$("body").on("click", ".cst_crop_buy", function (event) {
    event.preventDefault();
    var selected_variant = $(".selected-variant").attr("data-id");
    selected_variant = parseInt(selected_variant);

    if (!cropper) {
        alert("Invalid Input");
        return false;
    }

    if (!quantity) {
        alert("Invalid Input");
        return false;
    }

    const cropImage = cropper.getCroppedCanvas({ height: height_set, width: width_set }).toDataURL("image/png");

    const uploadImage = async (imageData) => {
        const uniqueUrl = 'https://image.everwallpaper.com/wp-json/custom/v1/upload-image?timestamp=' + new Date().getTime();
        try {
            const response = await fetch(uniqueUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer YourJWTTokenHere'
                },
                body: JSON.stringify({ image: imageData }),
            });

            if (!response.ok) {
                throw new Error('无法上传图像，请稍后再试。');
            }

            const data = await response.json();
            if (data.imageUrl) {
                console.log('返回的裁剪后图像链接:', data.imageUrl);
                $("#CropPath").val(data.imageUrl);
                var size_width_value = width_render;
                var size_height_value = height_render;
                $(".VariantHidden").val(selected_variant);
                $("#SizeCustom").val(
                    size_width_value + " x " + size_height_value
                );
                $(".product-form__input--quantity").val(quantity);
                $(".inputsize").val("");
                $("#mirror_set").prop("checked", false);

                // 模拟点击购物车按钮
                $(".cst_crop_buy").closest('form').submit();
            } else {
                throw new Error('未能获取图像链接。');
            }
        } catch (error) {
            console.error('上传图像时出现错误:', error);
        }
    };
    uploadImage(cropImage);
});
  
});